import React from "react"
import { makeStyles, createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

import { RouteComponentProps, navigate } from "@reach/router";
import Logo from "./Logo";
import { RootState } from '../store';
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme: Theme) =>
  createStyles(
    {
      root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }
  ),
);

interface PrivateRouteProps extends RouteComponentProps {
  component: any;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, location, ...rest }) => {
  const classes = useStyles();
  const user = useSelector((state: RootState) => state.user);

  if (user.userDataLoading || !location) {
    return (
      <div className={classes.root}>
        <Logo variant="big" />
      </div>
    );
  }

  if (user.agent === null && location.pathname !== '/sign-in') {
    navigate('/sign-in');
    return null;
  }

  return <Component {...rest} />

};

export default PrivateRoute;